/**
 * Referral
 *
 * @since 1.0.0
 */

import Cookies from 'js-cookie'

const Referral = () => {
  const hostname = window.location.origin
  const referrer = document.referrer
  const settings = document.querySelectorAll('.js-referrer')
  if (referrer && referrer.includes(hostname) !== true) {
    Cookies.set('bronkhorst_referrer', referrer, { expires: 1 })
  }
  if (Cookies.get('bronkhorst_referrer') !== undefined) {
    if (settings.length) {
      ;[...settings].forEach(setting => {
        const referrerString = setting.dataset.referrer
        const target = setting.dataset.link
        if (Cookies.get('bronkhorst_referrer').includes(referrerString) && referrerString !== '') {
          window.location.href = target
        }
      })
    }
  }
}

export default Referral



// WEBPACK FOOTER //
// ./src/js/modules/Referral.js